const products = [
  {
    name: "IDEL VPN",
    tagline: "Privacy Without Compromise",
    description:
      "A powerful VPN application engineered to protect your online identity, encrypt your traffic, and bypass geo-restrictions — all with blazing-fast speeds and a zero-log policy.",
    features: [
      "Military-grade AES-256 encryption",
      "Zero-log privacy policy",
      "One-tap connection",
      "Global server network",
      "Kill switch protection",
      "Split tunneling support",
    ],
    icon: "ri-shield-check-line",
    accent: "from-emerald-500 to-teal-500",
    image:
      "https://public.readdy.ai/ai/img_res/150a0174d3dd03234af3c6803c5fc1cc.jpg",
  },
  {
    name: "IDEL Cleaner",
    tagline: "Speed Up Your iPhone",
    description:
      "An intelligent cleaner application that removes junk files, duplicate photos, and unnecessary data — optimizing your device performance and freeing up valuable storage space.",
    features: [
      "Smart junk file detection",
      "Duplicate photo remover",
      "Storage space optimizer",
      "Memory booster",
      "Contact deduplication",
      "Privacy data cleaner",
    ],
    icon: "ri-delete-bin-line",
    accent: "from-orange-500 to-amber-400",
    image:
      "https://readdy.ai/api/search-image?query=modern%20iOS%20cleaner%20app%20interface%20on%20iPhone%2C%20light%20and%20dark%20mode%2C%20storage%20optimization%20dashboard%2C%20clean%20minimal%20design%2C%20progress%20rings%20and%20stats%2C%20professional%20mobile%20app%20UI%20screenshot%2C%20white%20and%20amber%20accent%20colors&width=600&height=700&seq=cleaner-product-01&orientation=portrait",
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-24 md:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16 md:mb-20">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-emerald-600 mb-3 block">
            Our Products
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 tracking-tight mb-4">
            Built for iOS. Built for You.
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Each product is carefully crafted to deliver exceptional performance, security, and user experience on Apple devices.
          </p>
        </div>

        {/* Products */}
        <div className="flex flex-col gap-16 md:gap-24">
          {products.map((product, idx) => (
            <div
              key={product.name}
              className={`flex flex-col ${idx % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"} items-center gap-10 lg:gap-16`}
            >
              {/* Image */}
              <div className="w-full lg:w-5/12 flex justify-center">
                <div className="relative w-64 md:w-72">
                  <div className={`absolute -inset-4 rounded-3xl bg-gradient-to-br ${product.accent} opacity-10 blur-2xl`}></div>
                  <img
                    src={product.image}
                    alt={`${product.name} app screenshot`}
                    className="relative w-full h-auto object-cover object-top rounded-2xl"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="w-full lg:w-7/12">
                <div className={`inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br ${product.accent} mb-5`}>
                  <i className={`${product.icon} text-white text-xl`}></i>
                </div>
                <h3 className="text-2xl md:text-4xl font-bold text-gray-900 mb-2 tracking-tight">
                  {product.name}
                </h3>
                <p className={`text-sm font-semibold tracking-widest uppercase bg-gradient-to-r ${product.accent} bg-clip-text text-transparent mb-4`}>
                  {product.tagline}
                </p>
                <p className="text-gray-500 text-base leading-relaxed mb-8">
                  {product.description}
                </p>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {product.features.map((feat) => (
                    <li key={feat} className="flex items-center gap-2.5 text-gray-700 text-sm">
                      <span className={`w-5 h-5 flex items-center justify-center rounded-full bg-gradient-to-br ${product.accent} flex-shrink-0`}>
                        <i className="ri-check-line text-white text-xs"></i>
                      </span>
                      {feat}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
